import {
  Toggler
} from './toggler';
export class Badges {
  constructor() {
    this._badges = new Map();
    this._filters = null;
    this._selectedCount = 0;
    this._listContainer = document.querySelector('.category__list');
    this._toggler = null;

    this._badgesClickHandler = this._badgesClickHandler.bind(this);
  }

  setBadges(filters, toggler) {
    this._filters = filters;
    this._toggler = toggler;
    this._filters.forEach((filter) => {
      const id = filter.getId();
      const name = filter.getElem().querySelector('.block-filter__name').textContent;
      const count = filter.getCheckedInputs().length;
      const badge = {
        id,
        name
      };
      this._badges.set(badge, count);
    });

    this._updateBadges();
    this._updateCountSelected();
    this._updateCountBadge();
  }

  setClickHandler(callback) {
    this._clickHandler = callback;
  }

  _badgesClickHandler(evt) {
    if (evt.target.closest('.filter-badge__button')) {
      const button = evt.target.closest('.filter-badge__button');
      this._clickHandler(button);
    }
  }

  _updateBadges() {
    this._removeBadges();

    for (let count of this._badges.values()) {
      if (count > 0) {
        this._createBadges();
        break;
      }
    }
  }

  _updateCountSelected() {
    this._selectedCount = 0;

    for (let count of this._badges.values()) {
      if (count > 0) {
        this._selectedCount++;
      }
    }
  }

  _updateCountBadge() {
    if (this._toggler !== null) {
      this._toggler.update(this._selectedCount);
    }
  }

  _createBadges() {
    const fragment = document.createDocumentFragment();
    const template = document.querySelector('#badges-data').content.querySelector('.category__badge');
    const cloneTemplate = template.cloneNode(true);
    this._badges.forEach((value, key) => {
      if (value > 0) {
        if (value === 1) {
          value = this._prepareDefaultValue(key);
        }
        cloneTemplate.prepend(this._createBadge(key, value));
      }
    });
    fragment.append(cloneTemplate);

    const badgesHtml = fragment.firstElementChild;
    badgesHtml.addEventListener('click', this._badgesClickHandler);

    this._listContainer.insertAdjacentElement('beforebegin', badgesHtml);
  }

  _prepareDefaultValue(key) {
    const currentFilter = this._filters.find(filter => filter.getId() === key.id);
    const checkedInput = currentFilter.getCheckedInput();

    return this._getLabelText(key, checkedInput);
  }

  _getLabelText(key, checkedInput) {
    if (this._isModels(key)) {
      return checkedInput.closest('.block-filter__item').querySelector('.block-filter__label--model').textContent;
    } else {
      return checkedInput.closest('.block-filter__item').querySelector('.control__label').textContent;
    }
  }

  _isModels(key) {
    return key.id === 'filter-16';
  }

  _removeBadges() {
    const badges = document.querySelector('.category__badge');
    if (badges === null) {
      return;
    }
    badges.remove();
  }

  _createBadge({
    id,
    name
  }, text) {
    const fragment = document.createDocumentFragment();
    const template = document.querySelector('#badge-data').content.querySelector('.filter-badge__item');
    const cloneTemplate = template.cloneNode(true);
    const button = cloneTemplate.querySelector('.filter-badge__button');
    button.prepend(name + ': ' + text);
    button.dataset.name = id;
    fragment.append(cloneTemplate);
    return fragment;
  }

}
